export default __webpack_public_path__ + "components/wind-icon/static/S@2x-1f821569972bdf349da083451289f76c.png";